import type { CallcenterLocalizationKeys } from "@callcenter/locales/types/Callcenter.types"

import type { FeedbackFormData } from "./types"
import { FeedbackReason } from "./types"

export const DEFAULT_FEEDBACK_FORM: FeedbackFormData = {
  reasons: new Set<FeedbackReason>(),
  missingFeaturesText: "",
  otherText: ""
}

export const FEEDBACK_REASON_LABELS: Record<FeedbackReason, keyof CallcenterLocalizationKeys> = {
  [FeedbackReason.notWithinBudget]: "component_commonKeys_feedbackModal_reasonNotWithinBudget",
  [FeedbackReason.missingFeatures]: "component_commonKeys_feedbackModal_reasonMissingFeatures",
  [FeedbackReason.noTimeToTest]: "component_commonKeys_feedbackModal_reasonNoTimeToTest",
  [FeedbackReason.other]: "component_commonKeys_feedbackModal_reasonOther"
}

export const TOTAL_TRIAL_DAYS = 14
